import solicitudes from "@/views/apps/solicitudes/validate";

import layouts from "@/layout";

export default {
  path: "/validate",
  name: "Validacion de Solicitud",
  component: solicitudes,
  meta: {
    auth: true,
    searchable: true,
    layout: layouts.navLeft,
    title: "Mis Solicitudes",
    tags: ["flow", "activity", "activity_flow"]
  }
};
